'use client';
import Link from 'next/link';
import {usePathname} from "next/navigation";
import {APP_AUTH_PAGES, FOOTER_PAGES, HashMapPathName, isActiveTab} from '@/app/config';
import styles from "./footer.module.css";

export default function Footer() {
    const pathname = usePathname();
    if (!HashMapPathName(FOOTER_PAGES, pathname)) {
        return null;
    }
    return (
        <>
            <footer className={styles.footer}>
                {FOOTER_PAGES.map((row) =>
                    <Link
                        id={row.nodeId}
                        className={`${styles.tab} ${isActiveTab(row.url, pathname) ? styles.tab_curr : ''}`}
                        href={`/${row.url === "/" ? "" : row.url}`}
                        key={row.name}
                    >
                        <span className={`s-icon ${row.iconClass} ${styles.tab_icon}`}></span>
                        <div className={`center`}>
                            <span className={`s-icon ${row.textClass} ${styles.tab_title_active}`}></span>
                            <div className={styles.tab_title} style={{marginTop: '.1rem'}}>{row.name}</div>
                        </div>
                    </Link>
                )}
            </footer>
            <div className="footer_panel"></div>
        </>
    )
}
